import React, { useState, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import 'modules/Drives/CalendarView/Partials/WeekView/Style/style.css'
import { Space } from 'antd'
import {
  StyledUlForCalendar,
  ListTag,
  CustomPopover,
  HoverText,
} from 'modules/Drives/CalendarView/Partials/MonthView/Style/style'
import DriveIcon from 'components/icons/DriveIcon'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import Cancel from 'components/icons/CancelIcon'
import ClockOrange from 'components/icons/ClockOrange'
import RequestIcon from 'components/icons/RequestIcon'

const WeekView = ({ listOfDrives }) => {

  const [initialEvents, setInitialEvents] = useState([])

  useEffect(() => {
    if (listOfDrives?.list?.length) {
      const listOfDrive = listOfDrives?.list?.map(item => item.drive)
      const regex = /T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z/
      let drives = listOfDrive?.map((drive, index) => {
        return {
          title: drive?.corporate?.name,
          start: drive?.startDate?.replace(
            regex,
            `T${drive?.startTime + ':00'}.000`
          ),
          end: drive?.endDate?.replace(regex, `T${drive?.endTime + ':00'}.000`),
          extendedProps: {
            id: index + 1,
            driveMode: drive?.driveMode,
            startTime: drive?.startTime,
            endTime: drive?.endTime,
            corporateStatus: drive?.corporateStatus,
          },
        }
      })
      let driveFilter = drives.filter(event => event.end !== undefined)
      setInitialEvents(driveFilter)
    }
  }, [listOfDrives?.list])


  const circleIcon = status => {
    switch (status) {
      case 'CONFIRMED':
        return <CheckCircleIcon />
      case 'PENDING':
        return <ClockOrange />
      case 'CANCELLED':
        return <Cancel />
      case 'REQUESTED':
        return <RequestIcon />
      default:
        break
    }
  }

 
  const timing = time => {
    const [hours, minutes] = time.split(':')
    let newHours = parseInt(hours)
    let timeOfDay = 'am'

    if (newHours >= 12) {
      newHours -= 12
      timeOfDay = 'pm'
    }

    if (newHours === 0) {
      newHours = 12
    }
    const formattedTime = `${newHours}:${minutes} ${timeOfDay}`
    return formattedTime
  }

  function toPascalCaseDrive(str) {
    return str?.replace('_', ' ').replace(/(\w)(\w*)/g, function (g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase()
    })
  }

  const renderEventContent = eventInfo => {
    const { event } = eventInfo

    return (
      <div className="fc-event-main">
        <CustomPopover
          content={
            <StyledUlForCalendar>
              <ListTag>
                <div>
                  <Space>
                    {event?.title}
                    {circleIcon(event?.corporateStatus)}
                  </Space>
                </div>
                {toPascalCaseDrive(event?.extendedProps?.driveMode)}
                <div>
                  Time:
                  {timing(event.extendedProps?.startTime) +
                    '-' +
                    timing(event.extendedProps?.endTime)}
                </div>
              </ListTag>
            </StyledUlForCalendar>
          }
        >
          <HoverText> {<DriveIcon fill={'blue'} />}</HoverText>
        </CustomPopover>
      </div>
    )
  }

  return (
    
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next',
          center: 'title',
          right: '',
        }}
        initialView="timeGridWeek"
        editable={true}
        selectable={true}
        selectMirror={false}
        dayMaxEvents={false}
        weekends={true}
        events={initialEvents} // alternatively, use the `events` setting to fetch from a feed
        eventContent={renderEventContent} // custom render function
        // eventsSet={handleEvents}
      />
    
  )
}

export default WeekView
